var _rect, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33301,
    y: 2.66675,
    width: 21.3333,
    height: 26.6667,
    rx: 3.33333,
    fill: "#DED2A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15.9997,
    cy: 16.0002,
    r: 6.66667,
    fill: "#FEFDF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8677 10.6181C15.9371 10.4292 16.2043 10.4292 16.2737 10.6181L17.4124 13.7173L19.0386 13.011C19.2186 12.9328 19.4013 13.1155 19.3231 13.2955L18.6171 14.921L21.7148 16.0591C21.9036 16.1285 21.9036 16.3957 21.7148 16.4651L18.6168 17.6034L19.3231 19.2297C19.4013 19.4097 19.2186 19.5924 19.0386 19.5142L17.4121 18.8078L16.2737 21.9062C16.2043 22.095 15.9371 22.0951 15.8677 21.9062L14.7295 18.8084L13.1044 19.5142C12.9244 19.5924 12.7417 19.4097 12.8199 19.2297L13.526 17.6039L10.4267 16.4651C10.2378 16.3957 10.2378 16.1285 10.4267 16.0591L13.5256 14.9205L12.8199 13.2955C12.7417 13.1155 12.9244 12.9328 13.1044 13.011L14.7292 13.7167L15.8677 10.6181Z",
    fill: "#A48300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 6.66691C6.66602 5.19415 7.85992 4.00024 9.33268 4.00024H22.666C24.1388 4.00024 25.3327 5.19415 25.3327 6.66691V25.3336C25.3327 26.8063 24.1388 28.0002 22.666 28.0002H9.33268C7.85992 28.0002 6.66602 26.8063 6.66602 25.3336V6.66691ZM9.33268 4.93358H22.666C23.6233 4.93358 24.3993 5.70962 24.3993 6.66691V25.3336C24.3993 26.2909 23.6233 27.0669 22.666 27.0669H9.33268C8.37539 27.0669 7.59935 26.2909 7.59935 25.3336V6.66691C7.59935 5.70962 8.37539 4.93358 9.33268 4.93358Z",
    fill: "#A48300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCard);
export default __webpack_public_path__ + "static/media/clear-card.ae9cdced0531989bb9eec67b1de4d1c6.svg";
export { ForwardRef as ReactComponent };